import { Router } from '../routing';
/**
 * Component class decorator: automatically do Route stuff
 */
export default function Route(path, options = {}) {
    return (target) => {
        Router.setRoute(path, target, options);
    };
}
